// Reveal horizontally without scrolling the page or moving keyboard focus.
export function revealCurrentStage(root) {
  const current = root?.querySelector('[aria-current="step"]');
  if (!current || !root.clientWidth) return;
  const bounds = root.getBoundingClientRect();
  const item = current.getBoundingClientRect();
  const shift = item.left < bounds.left ? item.left - bounds.left : item.right > bounds.right ? item.right - bounds.right : 0;
  if (shift) root.scrollLeft += shift;
}

export function initializeStageRails(scope = document) {
  scope.querySelectorAll(".process-stages").forEach(revealCurrentStage);
}
